<template>
  <v-img class="background-display">
    <v-container class="px-2">
      <Navbar />
        <v-card>
          <v-toolbar dark color="#00b2bb">
            <p class="ma-5 title-size font-weight-thin">{{ formData.name }}</p>
          </v-toolbar>
          <v-card-text>
            <v-alert v-model="alertAxios" border="left" close-text="Close Alert" dismissible dense outlined type="error">
                Ha ocurrido un error!
            </v-alert>
              <v-row>
                <v-col class="button-position mr-auto" sm="6" md="4">
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#00b2bb"
                      dark
                      v-on="on"
                      fab medium
                      absolute
                      bottom
                      right
                      fixed
                      class="button-position"
                    >
                      <v-icon>mdi-help</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title
                      class="headline"
                      color="#00b2bb"
                      primary-title
                    >
                      Ayuda
                    </v-card-title>
                    <v-card-text>
                      {{ formData.helpers }}
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Entendido
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                </v-col>
                <v-col xs="6" md="4" sm="4" lg="4" class="px-4">
                  <h4 class="font-weight-regular black--text mb-2">Fecha</h4>
                  <v-text-field
                    disabled
                    solo
                    v-model= fecha
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-form ref="form">
                  <v-container fluid>
                    <v-row>
                      <v-col class="mb-5" cols="12" sm="6">
                      <div v-if="this.signRut">
                      <h4 class="font-weight-regular black--text">Rut Registrado</h4>
                      <v-text-field
                        hide-details="auto"
                        disabled
                        :schema="{
                              label: '',
                              icon:''
                            }"
                        v-model="this.signRut"
                        solo
                      />
                      </div>
                      <div v-else-if="this.signPassport">
                      <h4 class="font-weight-regular black--text">Pasaporte Registrado</h4>
                      <v-text-field
                        hide-details="auto"
                        disabled
                        :schema="{
                              label: '',
                              icon:''
                            }"
                        v-model="this.signPassport"
                        solo
                      />
                      </div>
                      </v-col>
                      <v-col class="mb-5" cols="12" sm="6">
                      <h4 class="font-weight-regular black--text">Nombre y Apellidos</h4>
                      <v-text-field
                        hide-details="auto"
                        disabled
                        :schema="{
                              label: '',
                              icon:''
                            }"
                        v-model="this.signUser"
                        solo
                      />
                      </v-col>
                      <v-col class="mb-5" cols="12" sm="6" v-if="this.signPassport">
                      <div>
                      <h4 class="font-weight-regular black--text">Nacionalidad</h4>
                      <v-text-field
                        hide-details="auto"
                        disabled
                        :schema="{
                              label: '',
                              icon:''
                            }"
                        v-model="this.signNationality"
                        solo
                      />
                      </div>
                      </v-col>
                      <template v-for="(field, index) in formData.form">
                        <v-col :key="index" v-if="index !== 'userId' && index !== 'nombreCliente' && index !== 'rutCliente' &&
                         index !== 'numeroPasaporte' && index !== 'nombreFirmantes' && index !== 'emailFirmantes' && index !== 'rutFirmantes' &&
                         index !== 'tipoTramiteId'  && field.formFieldType === 'editable' &&
                         (field.showField ? selectedDocument.value === field.requiredValue : formValue[field.requiredField] !== field.requiredValue)" cols="12" sm="6">
                           <h4 class="font-weight-regular black--text">{{ field.label }}</h4>
                           <StringField v-if="field.fieldType === 'string' && index !== 'nacionalidad' && index !== 'nacionalidadCliente' && index !== 'comuna' && index !== 'comunaApoderado' && index !== 'municipalidad'"
                           v-model="formValue[index]"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              show: field.showField,
                              icon:'',
                              solo: true
                            }"
                           >
                           </StringField>
                           <RutField v-else-if="field.fieldType === 'rut'"
                           v-model="formValue[index]"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              icon:'',
                              solo: true
                            }"
                           >
                           </RutField>
                           <SingleSelect v-else-if="field.fieldType === 'singleSelect'"
                           :name="index"
                           :type="field.fieldType"
                           v-model="selectedDocument"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              items:field.fieldOptions.options,
                              icon:'',
                              solo: true
                            }"
                           >
                           </SingleSelect>
                           <DateField v-else-if="field.fieldType === 'date'"
                           v-model="formValue[index]"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              icon:'',
                              solo: true
                            }"
                           >
                           </DateField>
                           <NumberField v-if="field.fieldType === 'number'"
                           v-model="formValue[index]"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              icon:'',
                              solo: true
                            }"
                           >
                           </NumberField>
                           <textAreaField v-if="field.fieldType === 'textArea'"
                           v-model="formValue[index]"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              icon:'',
                              solo: true
                            }"
                           >
                           </textAreaField>
                           <CheckboxField v-else-if="field.fieldType === 'checkBox'"
                           :name="index"
                           :type="field.fieldType"
                           :schema="{
                              label: '',
                              optional: field.optional,
                              type: field.fieldType,
                              items:field.fieldOptions.options,
                              icon:'',
                              solo: true
                            }"
                           >
                           </CheckboxField>
                           <EmailField v-else-if="field.fieldType === 'email'"
                            v-model="formValue[index]"
                            :name="index"
                            :schema="{
                              label: '',
                              icon:'',
                              solo: true
                            }"
                          >
                          </EmailField>
                          <SingleSelect v-else-if="index === 'nacionalidad'"
                          :name="index"
                          v-model="formValue[index]"
                          :schema="{
                              label: '',
                              type: 'select',
                              items: options,
                              icon:'',
                              solo: true
                            }"
                          >
                          </SingleSelect>
                          <SingleSelect v-else-if="index === 'comuna'|| index === 'comunaApoderado' || index === 'municipalidad'"
                          :name="index"
                          v-model="formValue[index]"
                          :schema="{
                              label: '',
                              type: 'select',
                              items: optionsComunas,
                              icon:'',
                              solo: true
                            }"
                          >
                          </SingleSelect>
                        </v-col>
                      </template>
                    </v-row>
                  </v-container>
                </v-form>
                <!-- Descomentar cuando sea mas de un firmante -->
              <!-- <v-alert v-model="alertUser" border="left" close-text="Close Alert" dismissible dense outlined type="error">
                Error! El Rut o pasaporte del firmante no es el mismo que el del usuario registrado
              </v-alert>
              <v-alert v-model="alertUserEmail" border="left" close-text="Close Alert" dismissible dense outlined type="error">
                Error! El Correo del firmante no es el mismo que el del usuario registrado
              </v-alert>
              <v-form ref="formF">
                <v-layout wrap>
                <v-row justify="center" v-for="(firmante,index) in firmantes" :key="index">
                  <v-flex xs12 lg12 xl12 class="mx-2">
                    <h2 class="font-weight-regular primary--text mt-5">Firmante:</h2>
                    <h4 class="font-weight-regular black--text mt-5">Tipo de Documento</h4>
                    <v-radio-group v-model="radioButtonSelected[index]" row>
                      <v-radio label="RUT" value='rut'></v-radio>
                      <v-radio label="Pasaporte" value='pasaporte'></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn  class="ml-2 mt-4" v-on="on" color="normal" @click="deleteNewSignature(index)">Eliminar</v-btn>
                    </template>
                  <span>Eliminar Firmante</span>
                  </v-tooltip>
                    <v-col cols="12" xs="12" sm="3" md="3">
                      <StringField
                       v-model="firmante.nombre"
                       :name="firmante.nombre"
                       :schema="{
                          label: 'Nombres y Apellidos',
                          icon:'',
                          solo: true
                        }"
                      >
                      </StringField>
                    </v-col>
                    <v-col cols="12" xs="12" sm="3" md="3">
                      <EmailField
                          v-model="firmante.correo"
                          :name="firmante.correo"
                          :schema="{
                            label: 'Correo',
                            solo: true
                          }"
                        >
                        </EmailField>
                    </v-col>
                    <v-col cols="12" xs="12" sm="3" md="3">
                      <div v-if="radioButtonSelected[index] === 'rut'">
                        <RutField
                           v-model="firmante.rut"
                           :name="radioButtonSelected[index]"
                           :type="radioButtonSelected[index]"
                           :schema="{
                              label: 'RUT',
                              icon: '',
                              solo: true
                            }"
                           >
                           </RutField>
                      </div>
                      <div v-if="radioButtonSelected[index] === 'pasaporte'" >
                        <StringField
                           v-model="firmante.rut"
                           :name="radioButtonSelected[index]"
                           :schema="{
                              label: 'Pasaporte',
                              solo: true
                            }"
                           >
                           </StringField>
                      </div>
                    </v-col>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn  color="primary" class="mt-4" v-on="on" @click="addNewSignature(index)">Agregar</v-btn>
                      </template>
                    <span>Agregar Firmante</span>
                    </v-tooltip>
                </v-row>
                </v-layout>
              </v-form> -->
              <v-row cols="12" lg="6">
                <template >
                  <v-row class="ma-5 justify-left" xs="6" md="4" lg="4">
                    <v-btn color="normal" :to="'/newdocument/selectdocument'" style="margin-top: 40px;"
                    >Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="#00b2bb" dark @click="validationRules(id)" style="margin-top: 40px;"
                    >Crear</v-btn>
                  </v-row>
                </template>
              </v-row>
              </v-card-text>
            </v-card>
          <v-container>
        </v-container>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
  </v-img>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.button-position {
  margin-bottom: 35px;
}
</style>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import StringField from '../../components/fields/string/Field.vue'
import RutField from '../../components/fields/rut/Field.vue'
import SingleSelect from '../../components/fields/singleSelect/Field.vue'
import DateField from '../../components/fields/date/Field.vue'
import NumberField from '../../components/fields/number/Field.vue'
import textAreaField from '../../components/fields/textArea/Field.vue'
import CheckboxField from '../../components/fields/checkbox/Field.vue'
import EmailField from '../../components/fields/email/Field.vue'
import api from '@/plugins/api'
import countriesList from '../../mock/nationalities.json'
import comuna from '../../mock/comunas.json'
/* import numeral from '@/plugins/numeral' */
import store from '@/store/index.js'
/* import axios from 'axios' */

export default {
  name: 'Document',
  components: {
    Navbar,
    StringField,
    RutField,
    SingleSelect,
    DateField,
    NumberField,
    textAreaField,
    CheckboxField,
    EmailField
    /* Field: () => import('../../components/fields') */
  },
  data () {
    return {
      id: this.$route.params.id,
      signRut: store.state.user.attributes['custom:rut'],
      signPassport: store.state.user.attributes['custom:passport'],
      signNationality: store.state.user.attributes['custom:nationality'],
      signEmail: JSON.parse(localStorage.getItem('email')),
      signUser: store.state.user.attributes.name,
      date: new Date().toISOString().substr(0, 10),
      selectedDocument: '',
      fecha: '',
      contFirmas: 0,
      datos: [],
      formData: {},
      formValue: {},
      options: countriesList.countries,
      optionsComunas: comuna.comunas,
      firmantes: [{ nombre: '', correo: '', rut: '' }],
      radioButtonSelected: ['rut', 'rut', 'rut', 'rut'],
      alertAxios: false,
      overlay: false,
      dialog: false,
      alertUser: false,
      alertUserEmail: false
    }
  },
  mounted () {
    this.getForm(this.$route.params.id)
    this.$store.commit('setActualPage', this.$route.fullPath)
    this.getDate()
    this.overlay = !this.overlay
  },
  // Loading de 4 segundos
  /*  watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3500)
    }
  }, */
  methods: {
    // Obtiene los datos del formulario
    async getForm (id) {
      try {
        const response = await api.get(`formulario/${id}`)
        this.formData = response.data
        this.overlay = false
        /* console.log(response) */
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Error al hacer get' + error)
      }
    },
    // Envia los datos que fueron llenados
    async postDatos (id) {
      try {
        const response = await api.post(`crear/${id}`, {
          formulario: this.datos[0],
          firmantes: this.firmantes
        })
        /* console.log(response) */
        const tramiteId = response.data.tramiteId
        this.overlay = false
        this.$router.push(`/StatusDocument/${tramiteId}`)
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Error al enviar post' + error)
      }
    },
    handleSubmit (id) {
      var jsonData = { ...this.formValue }
      jsonData.fecha = this.fecha
      if (this.signRut) {
        jsonData.rutCliente = this.signRut
      } else {
        jsonData.numeroPasaporte = this.signPassport
        jsonData.nacionalidadCliente = this.signNationality
      }
      jsonData.nombreCliente = this.signUser
      this.datos.push(jsonData)
      this.overlay = !this.overlay
      // Pasando los datos a UpperCase
      this.datos = JSON.parse(JSON.stringify(this.datos, function (a, b) {
        return typeof b === 'string' ? b.toUpperCase() : b
      }))
      /* console.log(res) */
      /* console.log(this.datos) */
      this.postDatos(id)
    },
    /* Obtiene la fecha del dia en formato correcto */
    getDate () {
      const actualDAte = new Date()
      const day = actualDAte.getDate()
      const month = actualDAte.getMonth() + 1
      const year = actualDAte.getFullYear()
      this.fecha = day + '/' + month + '/' + year
    },
    validationRules (id) {
      this.checkUser()
      // descometar this.$refs.formF.validate(), this.alertUser === false y this.alertUserEmail === false, al momento de habilitar mas de un firmante
      if (this.$refs.form.validate() /* && this.$refs.formF.validate() && this.alertUser === false  && this.alertUserEmail === false */) {
        this.handleSubmit(id)
      }
    },
    /* Para cuando haya mas de un firmante, Valida si firmo con rut o pasaporte y que sea el mismo correo del usuario */
    /* checkUser () {
      this.alertUser = true
      this.alertUserEmail = true
      let idDocument = ''
      if (this.signRut) idDocument = this.signRut
      else idDocument = this.signPassport
      for (const lista of this.firmantes) {
        if (this.signEmail === lista.correo) this.alertUserEmail = false
        if (idDocument === lista.rut) this.alertUser = false
      }
    }, */
    // Como es un solo firmante se estan guardando sus datos automaticamente en el arreglo y se estan ordenando dependiendo si es rut o pasaporte
    checkUser () {
      if (this.signRut) {
        this.firmantes.unshift({
          correo: this.signEmail,
          nombre: this.signUser,
          rut: this.signRut
        })
        this.firmantes.pop()
      } else {
        this.firmantes.unshift({
          correo: this.signEmail,
          nombre: this.signUser,
          rut: this.signPassport
        })
        this.firmantes.pop()
      }
    },
    /* Agrega mas lineas de firmantes, tambien estan limitados al maxSignatures que llega del endpoint */
    addNewSignature (index) {
      let maxSignatures = ''
      if (this.formData.maxSignatures) {
        maxSignatures = this.formData.maxSignatures
      } else {
        maxSignatures = 1
      }
      if ((this.contFirmas + 1) < maxSignatures) {
        this.firmantes.push({
          nombre: '',
          correo: '',
          rut: ''
        })
        this.contFirmas++
      }
    },
    /* Elimina la fila de firmantes */
    deleteNewSignature (index) {
      if (index > 0) {
        this.firmantes.splice(index, 1)
        this.contFirmas--
      }
    }
  }
}
</script>
